import { API_ENDPOINTS, buildApiUrl } from "../config/api";

type ApiResponse<TData> = {
  status: number;
  message: string;
  data?: TData;
};

export type TwoFactorGenerateData = {
  otpauth_uri: string;
  qr_png_base64: string;
};

function getAuthHeaders(withJsonContentType = false): HeadersInit {
  const token = localStorage.getItem("access_token");
  if (!token) {
    throw new Error("Token de acesso não encontrado.");
  }

  const headers: HeadersInit = {
    Authorization: `Bearer ${token}`,
  };

  if (withJsonContentType) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
}

function resolveErrorMessage(json: ApiResponse<unknown> | null, fallback: string): string {
  const fromData =
    json?.data && typeof json.data === "object" && "message" in json.data
      ? String((json.data as { message?: string }).message ?? "")
      : "";
  return fromData || json?.message || fallback;
}

export async function generateTwoFactor() {
  const response = await fetch(buildApiUrl(API_ENDPOINTS.twoFactorGenerate), {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const json = (await response.json().catch(() => null)) as ApiResponse<TwoFactorGenerateData> | null;
  if (!response.ok) {
    throw new Error(resolveErrorMessage(json, "Não foi possível gerar o 2FA."));
  }

  if (!json?.data) {
    throw new Error("Resposta inválida ao gerar 2FA.");
  }

  return json.data;
}

export async function validateTwoFactor(code: string) {
  const response = await fetch(buildApiUrl(API_ENDPOINTS.twoFactorValidate), {
    method: "POST",
    headers: getAuthHeaders(true),
    body: JSON.stringify({ code }),
  });

  const json = (await response.json().catch(() => null)) as ApiResponse<unknown> | null;
  if (!response.ok) {
    throw new Error(resolveErrorMessage(json, "Não foi possível validar o código 2FA."));
  }

  return json;
}

export async function disableTwoFactor(code: string) {
  const response = await fetch(buildApiUrl(API_ENDPOINTS.twoFactorDisable), {
    method: "POST",
    headers: getAuthHeaders(true),
    body: JSON.stringify({ code }),
  });

  const json = (await response.json().catch(() => null)) as ApiResponse<unknown> | null;
  if (!response.ok) {
    throw new Error(resolveErrorMessage(json, "Não foi possível desativar o 2FA."));
  }

  return json;
}
